import { Color } from 'theme/enums';

export enum InvitationStatus {
  ACTIVE = 'active',
  INVITED = 'invited',
  NOT_INVITED = 'not-invited',
}

export const InvitationStatusLabel: Record<InvitationStatus, string> = {
  [InvitationStatus.ACTIVE]: 'Active',
  [InvitationStatus.INVITED]: 'Invited',
  [InvitationStatus.NOT_INVITED]: 'Not Invited',
};

export const InvitationStatusColorMap: Record<InvitationStatus, string> = {
  [InvitationStatus.ACTIVE]: Color.SUCCESS,
  [InvitationStatus.INVITED]: Color.PRIMARY,
  [InvitationStatus.NOT_INVITED]: Color.DANGER,
};

export enum ContactStatus {
  ACTIVE = 'active',
  DELETED = 'deleted',
}
